import { Component, Host, h, Method, State, Prop, Listen, EventEmitter, Event, Watch, Element } from '@stencil/core';

@Component({
  tag: 'me-expander',
  styleUrl: 'me-expander.scss',
  shadow: false,
})
export class MeExpander {

  @Element() host: HTMLMeExpanderElement;

  @Event() meExpanderToggle: EventEmitter<HTMLMeExpanderElement>;

  @State() isAnimated = false;
  @State() isExpandable = false;

  @Prop() maxHeight = 200;
  @Prop() moreButtonLabel = 'Mehr lesen';
  @Prop() lessButtonLabel = 'Weniger lesen';

  @Prop({ mutable: true, reflect: true }) isExpanded = false;
  @Watch('isExpanded')
  handleIsExpandedChange() {
    this.meExpanderToggle.emit(this.host);
  }

  @Listen('resize', { target: 'window' })
  handleResize() {
    this.updateIsExpandable();
  }

  private content: HTMLDivElement;

  componentDidLoad() {
    this.updateIsExpandable();
    this.enableAnimations();
  }

  render() {
    const classList = [
      'me-expander',
      this.isAnimated ? 'me-expander--animated' : null,
      this.isExpandable ? 'me-expander--expandable' : null,
      this.isExpanded ? 'me-expander--expanded' : null,
    ].filter(c => !!c).join(' ');

    return (
      <Host class={classList}>
        <div
          class="me-expander__content"
          ref={el => this.content = el}
          style={{ maxHeight: this.isExpanded ? `${this.content.scrollHeight}px` : `${this.maxHeight}px` }}
        >
          <slot />
        </div>
        {this.isExpandable
          ? (
            <me-button variant="link" inline={false} icons={true} onClick={this.toggle.bind(this)}>
              {this.isExpanded ? this.lessButtonLabel : this.moreButtonLabel}
              <span slot="icon-right">
                <i class={{
                  'fa-solid': true,
                  'fa-chevron-up': this.isExpanded,
                  'fa-chevron-down': !this.isExpanded
                }} />
              </span>
            </me-button>
          )
          : null
        }
      </Host>
    );
  }

  @Method()
  async toggle() {
    this.isExpanded = !this.isExpanded;
  }

  private updateIsExpandable() {
    this.isExpandable = this.content.offsetHeight >= this.maxHeight;
  }

  private enableAnimations() {
    setTimeout(() => this.isAnimated = true);
  }

}
